// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8e1d1b7a","160":"4ff5b58e","208":"991d84de","293":"384073b6","488":"7213179a","516":"5009c147","519":"39fb57f6","553":"5a25e8e8","917":"fec39127","946":"87a80246","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};